import { useContext } from 'react';
import ExecutionsContext, { ExecutionsCtxType } from './executions-context';

export default function useExecutions(): ExecutionsCtxType {
  return useContext(ExecutionsContext);
}
